/// <amd-module name="DistributedTaskUI/SecurityComponent/PipelinePermissionsAuthorization/Actions/PipelinesAuthorizationActionsCreator" />
import { PipelinesAuthorizationActionsHub } from "PipelinePermissionsAuthorization/Actions/PipelinesAuthorizationActionsHub";
import { PipelinesAuthorizationSource } from "PipelinePermissionsAuthorization/Source/PipelinesAuthorizationSource";
import { ResourcePipelinePermissions } from "PipelineChecks/Authorization/Client/Contracts/PipelinePermissions";
import { BuildDefinitionReference } from "DistributedTaskUI/SecurityComponent/PipelinePermissionsAuthorization/Source/Build/Contracts/Build";

export class PipelinesAuthorizationActionsCreator {
    constructor(actions: PipelinesAuthorizationActionsHub, source: PipelinesAuthorizationSource) {
        this._actions = actions;
        this._source = source;
    }

    public static getKey(): string {
        return "pipelines-security-actions-creator";
    }

    public initializeAuthorizedDefinitions(resourceType: string, resourceId: string): void {
        this._source.getPipelinePermissionsForResource(resourceType, resourceId).then((authorizedDefinitions: ResourcePipelinePermissions) => {
            this._actions.initializeAuthorizedDefinitions.invoke(authorizedDefinitions);
            this._loadAuthorizedBuildDefinitions(authorizedDefinitions);
        }).catch((error) => {
            this.setErrorMessage(error.message);
        });

        this._source.getAllBuildDefinitions().then((buildDefinitions: BuildDefinitionReference[]) => {
            this._actions.initializeAllPipelineDefinitions.invoke(buildDefinitions);
        });
    }

    public updatePipelinePermisionsForResource(resourceType: string, resourceId: string, modifiedAuthorizedDefinitions: ResourcePipelinePermissions): void {
        modifiedAuthorizedDefinitions.resource.id = undefined;
        modifiedAuthorizedDefinitions.resource.type = undefined;
        modifiedAuthorizedDefinitions.allPipelines = undefined;

        this._source.updatePipelinePermisionsForResource(resourceType, resourceId, modifiedAuthorizedDefinitions).then((authorizedDefinitions: ResourcePipelinePermissions) => {
            this._actions.initializeAuthorizedDefinitions.invoke(authorizedDefinitions);
            this._loadAuthorizedBuildDefinitions(authorizedDefinitions);
        }).catch((error) => {
            this.setErrorMessage(error.message);

            //the API call did not return 200 response => we need to reload authorizedDefinitions & keep the error message
            this._source.getPipelinePermissionsForResource(resourceType, resourceId).then((authorizedDefinitions: ResourcePipelinePermissions) => {
                this._actions.initializeAuthorizedDefinitions.invoke(authorizedDefinitions);
                this.setErrorMessage(error.message);
            });
        });
    }

    public toggleAllPipelinesRestriction(resourceType: string, resourceId: string, modifiedAuthorizedDefinitions: ResourcePipelinePermissions): void {
        this._source.updatePipelinePermisionsForResource(resourceType, resourceId, modifiedAuthorizedDefinitions).then((authorizedDefinitions: ResourcePipelinePermissions) => {
            this._actions.toggleAllPipelinesRestriction.invoke(authorizedDefinitions);
        }).catch((error) => {
            this.setErrorMessage(error.message);
        });
    }

    private _loadAuthorizedBuildDefinitions(authorizedDefinitions: ResourcePipelinePermissions): void {
        if (authorizedDefinitions.pipelines) {
            let buildDefinitionIds = authorizedDefinitions.pipelines.map((definition) => { return definition.id; });
            this._source.getAuthorizedBuildDefinitions(buildDefinitionIds).then((buildDefinitions: BuildDefinitionReference[]) => {
                this._actions.initializeAuthorizedPipelineDefinitions.invoke(buildDefinitions);
            });
        }
    }

    public setErrorMessage(errorMessage: string): void {
        this._actions.setErrorMessage.invoke(errorMessage);
    }

    private _actions: PipelinesAuthorizationActionsHub;
    private _source: PipelinesAuthorizationSource;
    private _noAuthorizedPipelinesError = "Resource is not authorized for any pipeline.";
}
